// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1geRx","col":"styles_col__2cIjQ","fulfillmentStatus":"styles_fulfillmentStatus__1ZE6i","emailCol":"styles_emailCol__1K7Cc"};